import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CustomInputComponent } from './custom-input.page';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [CustomInputComponent],
  imports: [CommonModule, IonicModule, ReactiveFormsModule, TranslateModule],
  exports: [CustomInputComponent],
})
export class CustomInputModule {}
